
import { WDFormBasic } from './wd-form-basic';
import WDUploader from '../util/wd-uploader';

export class WDFormImage extends WDFormBasic
{

	#value = null;
	#button = null;
	#image = null;
	#uploader;

	constructor(opts)
	{
		const cfg = {
			value: null,
			fetch: null,
			putFileName: true,
		};

		Object.assign(cfg, opts);

		const figure = wdc('<figure/>');
		super(figure, opts);

		this.#image = wdc('<img/>');
		figure.append(this.#image);

		this.value = cfg.value;
		this.#image.addEventListener('click', () => this.selectImage());

		if (opts?.readonly)
		{
			this.classList.add('is-readonly');
		}

	};

	get readonly() { return this.classList.contains('is-readonly');};
	set readonly(val)
	{
		if (val == true) this.classList.add('is-readonly');
		else this.classList.remove('is-readonly');
	};

	get image() { return this.#image; };

	set value(data)
	{
		if (data == null || String(data).length == '0') 
		{
			this.#image.setAttribute('src', '/assets/images/no-image.png');
		}
		else 
		{
			const ts = Math.floor(new Date().getTime() / 1000);
			this.#image.setAttribute('src', `${data}?timestamp=${ts}`);
		}

		this.trigger('value:set');
	};

	get value()
	{
		return this.#value;
	};

	selectImage()
	{
		if (this.readonly) return false;

		const opts = {
			container: this,
			fetch: this.config.fetch,
			putFileName: this.config.putFileName,
		};

		const upper = new WDUploader(opts);
		upper.on('upload:complete', (result) =>
		{
			this.value = result.detail.response;
			this.trigger('change');	//put here because guaranteed user interaction
		});

		upper.upload();

	}

	cleanupCallback()
	{
		// Clean up uploader if it exists
		if (this.#uploader) {
			this.#uploader = null;
		}

		// Clear references
		this.#button = null;
		this.#image = null;
		this.#value = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-form-image', WDFormImage);
